import axios from 'axios';
import { Message } from 'element-ui';
import router from '../router';
import globalConfig from '@/global-config';

const isBaseURL = Object.values(globalConfig).filter(i => !i.includes('/usercenter'));
axios.defaults.headers.post['Content-Type'] = 'application/json;charset=UTF-8';
const service = axios.create({
  baseURL: globalConfig.host,
  timeout: 30 * 1000,
});
service.interceptors.request.use(
  (config) => {
    console.log('[request]:', config);
    const loginInfo = window.localStorage.getItem('LOGIN_INFO') ? JSON.parse(window.localStorage.getItem('LOGIN_INFO')) : {};
    if (loginInfo.sessionId && isBaseURL.includes(config.baseURL)) {
      config.headers.common.userName = loginInfo.userName || '';
      config.headers.sessionId = loginInfo.sessionId || '';
    }
    if (config.baseURL === globalConfig.musMerchantHost || config.url.includes('/mus-merchant')) {
      delete config.headers.common.userName;
      delete config.headers.userName;
    }
    if (!isBaseURL.includes(config.baseURL)) {
      config.headers['X-Source'] = 'bussLine=PAYBU_JH;appType=30135;sdkVer=2.0.0;deviceId=';
    }
    return config;
  },
  (error) => {
    console.log('[requestErr]:', error);
    return Promise.reject(error);
  },
);

const noToastArr = [
  '/usercenter/v2/openapi/login',
];

service.interceptors.response.use(
  (response) => {
    console.log('[response]:', response);
    if (response.headers['content-type'] && response.headers['content-type'] === "text/xml; charset=utf-8;") {
      return response.data;
    } if (response.headers['content-type'] && response.headers['content-type'].includes('application/vnd.ms-excel')) {
      const headerFileName = response.headers['content-disposition'].split(';filename=')[1];
      const url = window.URL.createObjectURL(new Blob([response.data], { type: 'application/vnd.ms-excel' }));
      const link = document.createElement('a');
      link.href = url;
      link.target = '_blank';
      link.setAttribute('download', decodeURI(headerFileName));
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      return response.data;
    }
    // 懒得改接口逻辑，直接拦截返回了~
    if (response.config.url.includes('/usercenter/v2/openapi/modifyPassword')) {
      return response;
    }
    if (response.data.error_code && ![0, '0'].includes(response.data.error_code)) {
      if (response.config.url.includes('/merchant-info/filterUser') && response.data.error_code === -3009) {
        Message.error('该账号无操作权限');
      } else {
        Message.error(response.data.error_msg || 'Error');
        if (response.data.error_code === -1005) {
          router.push({ path: '/login' });
        }
      }
    } else if (response.data.code && ![0, '0'].includes(response.data.code)) {
      if (!noToastArr.some(i => response.config.url.includes(i))) {
        Message.error(response.data.msg || 'Error');
        if (response.data.code === 10001) {
          router.push({ path: '/login' });
        }
      }
      return Promise.reject(response);
    }
    return response;
  },
  (error) => {
    console.log('[responseErr]:', error);
    Message.error('网络请求失败，请重试！');
    return Promise.reject(error.response);
  },
);

export default service;
